export default __webpack_public_path__ + "static/media/subscription-dates.04d079cb.svg";